import html from '../../assets/html.svg';
import css from '../../assets/css.svg';
import javascript from '../../assets/javascript.svg';
import react from '../../assets/react.svg';
import sass from '../../assets/sass.svg';
import bootstrap from '../../assets/bootstrap.svg';
import angular from '../../assets/angular.svg';
import vue from '../../assets/vue.svg';
import node from '../../assets/node.svg';
import python from '../../assets/python.svg';

const data = [
  {
    id: 1,
    img: html,
    name: 'html',
    level: 'beginner',
    lessons: 20,
    students: 15630,
  },
  {
    id: 2,
    img: css,
    name: 'css',
    level: 'beginner',
    lessons: 30,
    students: 12560,
  },
  {
    id: 3,
    img: sass,
    name: 'sass',
    level: 'intermediate',
    lessons: 60,
    students: 8560,
  },
  {
    id: 4,
    img: bootstrap,
    name: 'bootstrap',
    level: 'intermediate',
    lessons: 20,
    students: 10560,
  },
  {
    id: 5,
    img: javascript,
    name: 'javascript',
    level: 'intermediate',
    lessons: 20,
    students: 10560,
  },
  {
    id: 6,
    img: react,
    name: 'react',
    level: 'advanced',
    lessons: 60,
    students: 8560,
  },
  {
    id: 7,
    img: angular,
    name: 'angular',
    level: 'advanced',
    lessons: 60,
    students: 8560,
  },
  {
    id: 8,
    img: vue,
    name: 'vue',
    level: 'advanced',
    lessons: 60,
    students: 8560,
  },
  {
    id: 9,
    img: node,
    name: 'node',
    level: 'begginer',
    lessons: 60,
    students: 8560,
  },
  {
    id: 10,
    img: python,
    name: 'python',
    level: 'begginer',
    lessons: 60,
    students: 8560,
  },
];

export default data;
